/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';

import { TrafficLogCinematicStore } from '../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.store';
import { ITrafficLogsStates, TrafficLogsStore } from '../../traffic-logs/traffic-logs.store';
import { VsAppProfileType } from '../../../logs.types';

import * as l10n from './log-cinematic-top-info.component.l10n';
import './log-cinematic-top-info.component.less';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Component used for showing the top info section of the log cinematic view.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-top-info',
    templateUrl: 'log-cinematic-top-info.component.html',
})
export class LogCinematicTopInfoComponent {
    public readonly globalL10nKeys = globalL10nKeys;

    public readonly l10nKeys = l10nKeys;

    public readonly vsAppProfileType$ = this.logsStore.vsAppProfileType$;

    public readonly defaultVsIp$ = this.logsStore.defaultVsIp$;

    public readonly hasWafPolicy$ = this.logsStore.hasWafPolicy$;

    public readonly VsAppProfileType = VsAppProfileType;

    public readonly clientRtt$ = this.logCinematicStore.clientRtt$;

    public readonly serverRtt$ = this.logCinematicStore.serverRtt$;

    public readonly responseCode$ = this.logCinematicStore.responseCode$;

    public readonly serverResponseCode$ = this.logCinematicStore.serverResponseCode$;

    public readonly appResponseTime$ = this.logCinematicStore.appResponseTime$;

    public readonly dataTransferTime$ = this.logCinematicStore.dataTransferTime$;

    public readonly totalTime$ = this.logCinematicStore.totalTime$;

    public readonly clientIps$ = this.logCinematicStore.clientIps$;

    public readonly clientSrcPort$ = this.logCinematicStore.clientSrcPort$;

    public readonly clientDestPort$ = this.logCinematicStore.clientDestPort$;

    public readonly vsIps$ = this.logCinematicStore.vsIps$;

    public readonly serverIps$ = this.logCinematicStore.serverIps$;

    public readonly serverSrcPort$ = this.logCinematicStore.serverSrcPort$;

    public readonly serverDestPort$ = this.logCinematicStore.serverDestPort$;

    public readonly sourceIps$ = this.logCinematicStore.sourceIps$;

    public readonly serverConnectionSrcIps$ = this.logCinematicStore.serverConnectionSrcIps$;

    public readonly serviceEngine$ = this.logCinematicStore.serviceEngine$;

    public readonly vcpuId$ = this.logCinematicStore.vcpuId$;

    public readonly pool$ = this.logCinematicStore.pool$;

    public readonly poolName$ = this.logCinematicStore.poolName$;

    public readonly serverName$ = this.logCinematicStore.serverName$;

    constructor(
        l10nService: L10nService,
        private readonly logsStore: TrafficLogsStore<ITrafficLogsStates>,
        public readonly logCinematicStore: TrafficLogCinematicStore,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
